var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',[_c('router-view'),_c('notifications',{attrs:{"group":"foo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }